/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Imported_SuccessInputs */

const en_settings_imported_success = /** @type {(inputs: Settings_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings imported successfully. Please refresh the page for changes to take effect.`)
};

const fr_settings_imported_success = /** @type {(inputs: Settings_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres importés avec succès. Veuillez actualiser la page pour que les changements prennent effet.`)
};

const de_settings_imported_success = /** @type {(inputs: Settings_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Einstellungen wurden erfolgreich importiert. Bitte aktualisieren Sie die Seite, damit die Änderungen wirksam werden.`)
};

const it_settings_imported_success = /** @type {(inputs: Settings_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni importate correttamente. Aggiorna la pagina affinché le modifiche abbiano effetto.`)
};

const ru_settings_imported_success = /** @type {(inputs: Settings_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки успешно импортированы. Пожалуйста, обновите страницу, чтобы изменения вступили в силу.`)
};

const es_settings_imported_success = /** @type {(inputs: Settings_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La configuración se importó correctamente. Actualice la página para que los cambios surtan efecto.`)
};

const zh_cn2_settings_imported_success = /** @type {(inputs: Settings_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置已成功导入。请刷新页面以使更改生效。`)
};

const ja_settings_imported_success = /** @type {(inputs: Settings_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定が正常にインポートされました。変更を有効にするにはページを更新してください。`)
};

const hi_settings_imported_success = /** @type {(inputs: Settings_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स सफलतापूर्वक आयात हो गईं। परिवर्तनों को प्रभावी होने के लिए कृपया पृष्ठ को रीफ़्रेश करें।`)
};

const pt_pt2_settings_imported_success = /** @type {(inputs: Settings_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações importadas com sucesso. Atualize a página para que as alterações entrem em vigor.`)
};

/**
* | output |
* | --- |
* | "Settings imported successfully. Please refresh the page for changes to take effect." |
*
* @param {Settings_Imported_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const settings_imported_success = /** @type {((inputs?: Settings_Imported_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Imported_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_imported_success(inputs)
	if (locale === "de") return de_settings_imported_success(inputs)
	if (locale === "it") return it_settings_imported_success(inputs)
	if (locale === "ru") return ru_settings_imported_success(inputs)
	if (locale === "es") return es_settings_imported_success(inputs)
	if (locale === "zh-CN") return zh_cn2_settings_imported_success(inputs)
	if (locale === "ja") return ja_settings_imported_success(inputs)
	if (locale === "hi") return hi_settings_imported_success(inputs)
	if (locale === "pt-PT") return pt_pt2_settings_imported_success(inputs)
	return en_settings_imported_success(inputs)
});